import { useEffect } from 'react';
import { ContactAssignments } from 'nekst-api';

export function useProjectTaskDefaultAssigneeHelper(
  projectAssignments: ContactAssignments[],
  value: { personId?: number }[],
  onChangeCallback: (newValue: { personId?: number }[]) => void,
) {

  const assignToCurrentUserByDefault = async () => {
    const numberOfCheckedElements = (value || [])
      .filter((item) => item.personId).length;

    if (projectAssignments && numberOfCheckedElements === 0) {
      const defaultAssignee = projectAssignments.find((v) => v.isAssignable)!;
      onChangeCallback([
        {
          personId: defaultAssignee.personId,
        },
        ...value || [],
      ]);
    }
  };

  useEffect(() => {
    if (projectAssignments.length > 0) {
      assignToCurrentUserByDefault();
    }
  }, [projectAssignments.length, JSON.stringify(value)]);
}
